import React from "react";
import PageHeading from "../../components/PageHeading";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import * as Yup from "yup";
import customPriceServices from "../../services/customPrice";
import CustomPriceForm from "../../components/Forms/CustomPriceForm";
import { useQuery } from "react-query";
import DSpinner from "../../components/DSpinner";

const validationSchema = Yup.object().shape({
  custom_price: Yup.number()
    .typeError("يجب ان يكون رقم")
    .required("هذا الحقل مطلوب"),
  user_id: Yup.number()
    .typeError("يجب ان يكون رقم")
    .required("هذا الحقل مطلوب"),
});

const EditCustomPrice = ({ title }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, error } = useQuery(["getCustomPrice", id], () => {
    return customPriceServices.getCustomPrice(id);
  });
  const onSubmit = (values, { setSubmitting }) => {
    const formattedData = {
      custom_price: values.custom_price,
    };
    const subitem_id = values.subitem_id;
    customPriceServices
      .editCustomPrice(formattedData, id)
      .then((res) => {
        toast.success("تم التعديل بنجاح");
        setTimeout(() => {
          setSubmitting(false);
        }, 1500);
        navigate(`/subitems/${subitem_id}/custom-prices`);
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.status === 404) {
          toast.error("غير موجود السجل");
        } else {
          toast.error("حصل خطأ اثناء التحديث");
          console.log(err);
        }
        setTimeout(() => {
          setSubmitting(false);
        }, 1500);
      });
  };
  if (error) {
    return <Navigate to="/404" />;
  }
  return (
    <div>
      {" "}
      <PageHeading>{title}</PageHeading>
      {isLoading ? (
        <DSpinner />
      ) : (
        <CustomPriceForm
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          subitemId={id}
          isUpdate={true}
          initialValues={{
            ...data.data.data,
          }}
          btnText="تعديل"
        />
      )}
    </div>
  );
};

export default EditCustomPrice;
